"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.is-array.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.parse-float.js");
var _react = _interopRequireWildcard(require("react"));
var _types = require("./types");
var _Form = _interopRequireDefault(require("./Form"));
var _Results = _interopRequireDefault(require("./Results"));
var _calculate = _interopRequireDefault(require("./calculate"));
var _validate = _interopRequireDefault(require("./validate"));
var _constellation = require("@zillow/constellation");
var S = _interopRequireWildcard(require("./styles"));
var _styledComponents = require("styled-components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // Constellation
// Misc / Utils
var CalculationState = /*#__PURE__*/function (CalculationState) {
  CalculationState[CalculationState["INPUT_PARAMS"] = 0] = "INPUT_PARAMS";
  CalculationState[CalculationState["DISPLAY_RESULTS"] = 1] = "DISPLAY_RESULTS";
  CalculationState[CalculationState["ERRORED"] = 2] = "ERRORED";
  return CalculationState;
}(CalculationState || {});
var TENANT_STATUSES = [_types.TenantStatus.MOVE_IN, _types.TenantStatus.MOVE_OUT];
var ProratedRentCalculator = function ProratedRentCalculator() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    itc: '',
    t: ''
  };
  var itc = props.itc,
    t = props.t;
  var _useState = (0, _react.useState)(CalculationState.INPUT_PARAMS),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = (0, _react.useState)({
      tenantStatus: TENANT_STATUSES[0]
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    params = _useState4[0],
    setParams = _useState4[1];
  var clearParams = function clearParams() {
    return setParams({
      tenantStatus: TENANT_STATUSES[0]
    });
  };
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var clearErrors = function clearErrors() {
    return setErrors({});
  };
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    proratedRent = _useState8[0],
    setProratedRent = _useState8[1];
  var handleCalculateButtonClick = function handleCalculateButtonClick() {
    var validateResult = (0, _validate["default"])(params);
    if ('errors' in validateResult) {
      setErrors(validateResult.errors);
      setState(CalculationState.ERRORED);
    } else {
      clearErrors();
      var tenantStatus = params.tenantStatus,
        monthlyRent = params.monthlyRent,
        moveDate = params.moveDate;
      setProratedRent(
      // typecasting is safe because params have passed validation
      (0, _calculate["default"])(tenantStatus, parseFloat(monthlyRent), new Date(moveDate)));
      setState(CalculationState.DISPLAY_RESULTS);
    }
  };
  var handleReset = function handleReset() {
    clearParams();
    setState(CalculationState.INPUT_PARAMS);
  };
  (0, _react.useEffect)(function () {
    // continuously validate if user is in ERRORED state
    if (state === CalculationState.ERRORED) {
      var validationResult = (0, _validate["default"])(params);
      if ('errors' in validationResult) {
        setErrors(validationResult.errors);
      } else {
        clearErrors();
      }
    }
  }, [params, state]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.ThemeProvider, {
    theme: _constellation.ThemeConstellation,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(S.Content, {
      cardType: "secondary",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(S.CenterText, {
        as: "h1",
        fontType: _constellation.FONT_TYPES.h4,
        marginBottom: "sm",
        children: "Prorated rent calculator"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(S.CenterText, {
        as: "p",
        fontType: _constellation.FONT_TYPES.body,
        marginBottom: "md",
        children: "Calculate your tenant's prorated rent."
      }), (state === CalculationState.INPUT_PARAMS || state === CalculationState.ERRORED) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Form["default"], {
        tenantStatuses: TENANT_STATUSES,
        setTenantStatus: function setTenantStatus(tenantStatus) {
          return setParams(_objectSpread(_objectSpread({}, params), {
            tenantStatus: tenantStatus
          }));
        },
        setMonthlyRent: function setMonthlyRent(monthlyRent) {
          return setParams(_objectSpread(_objectSpread({}, params), {
            monthlyRent: monthlyRent
          }));
        },
        setMoveDate: function setMoveDate(moveDate) {
          return setParams(_objectSpread(_objectSpread({}, params), {
            moveDate: moveDate
          }));
        },
        handleCalculateButtonClick: handleCalculateButtonClick,
        errors: errors
      }), state === CalculationState.DISPLAY_RESULTS && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Results["default"], {
        reset: handleReset,
        proratedRent: proratedRent,
        itc: itc,
        t: t
      })]
    })
  });
};
var _default = exports["default"] = ProratedRentCalculator;